import script from "./LessonComments.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonComments.vue?vue&type=script&setup=true&lang=js"

import "./LessonComments.vue?vue&type=style&index=0&id=59fd0962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fd0962"]])

export default __exports__